delivery_options-table
  section.app-table
    header.app-table-header
      .row
        .col-12.col-md-5 { opts.locale.header.contents.label }
        .col-12.col-md-5 { opts.locale.header.attentions.label }
        .col-12.col-md-1  { opts.locale.header.position.label }
        .col-12.col-md-1.text-right
    .app-table-body
      .row(each="{ opts.items }")
        .col-12.col-md-5 { contents }
        .col-12.col-md-5 { attentions }
        .col-12.col-md-1 { position }
        .col-12.col-md-1.text-right
          a.btn.btn-primary.editable(href="{ edit_path }")
            i.feather.icon-edit
  shared-paginate(tag-scope="{this.tagScope}.paginate")
  script(type="typescript").
    this.mixin('table');
  style(scoped).
    :scope {
      display: block;
    }
